module.exports = __webpack_public_path__ + "img/logo-2.ac6cb9d4.png";